import api from '@/lib/api/crate-core-api-client'
import { withDownloadAttributionParams } from '@/lib/attribution/download'

/** Enqueue by slug. Do not verify with GET: reading the queue drains it. */
export async function enqueueBlenderAsset(slug: string): Promise<void> {
  const { data } = await api.post<{ success?: boolean }>(
    withDownloadAttributionParams('/plugins/legacy/blender/queue'),
    { slug }
  )

  if (data?.success !== true) {
    throw new Error('Could not download through blender addon')
  }
}
